/**
 * Returns true if a Firebase/Firestore error represents an offline or
 * network-unavailable condition (e.g. "Failed to get document because the
 * client is offline.").
 */
export function isOfflineError(error) {
  return (
    error?.code === 'unavailable' ||
    (typeof error?.message === 'string' && error.message.includes('client is offline'))
  );
}
